
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <b-link :to="{ name: 'WorkDetail', params: { id: work.id } }">
    <div class="giga-flexible_card">
      <div class="giga-flexible_card_header">
        <h3 class="giga-flexible_card_title">{{ work.name }}
          <span class="tooltip-container"  v-if="work.cofracState === 'BOTH' || work.cofracState === 'ONLY_COFRAC'">
                  <svg class="warning-icon" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
                    <path class="triangle"
                          d="M7.5 1.2
                         C7 1.2 6.7 1.5 6.5 1.8
                         L0.8 11.2
                         A1.5 1.5 0 0 0 2.2 13
                         H12.8
                         A1.5 1.5 0 0 0 14.2 11.2
                         L8.5 1.8
                         C8.3 1.5 8 1.2 7.5 1.2Z"
                    />
                    <path class="exclamation-mark"
                          d="M7.5 3.5C7.75 3.5 8 3.75 8 4L7.8 8C7.8 8.25 7.6 8.5 7.5 8.5C7.4 8.5 7.2 8.25 7.2 8L7 4C7 3.75 7.25 3.5 7.5 3.5Z"
                    />
                    <circle class="exclamation-mark" cx="7.5" cy="10.5" r="0.8" />
                  </svg>
                  <span class="tooltip-text">{{ $t("quality_control_required") }}</span>
                </span>
          <span class="tooltip-container" v-if="work.isRgeInstaller">
              <img
                  src="@/assets/images/rge.png"
                  alt="RGE"
                  class="rge-icon"
              />
                  <span class="tooltip-text">{{ $t("rge_installer_required") }}</span>
          </span>
        </h3>
        <span class="giga-flexible_card_badge">{{ work.numberOfNotifications }}</span>
      </div>
      <div class="giga-flexible_card_body">
        <div class="giga-flexible_card_details">
          <ul class="giga-simulation_card_details">
            <li class="giga-simulation_card_detail">
              <span>état</span>
              <label class="inProgress">{{$t(work.status)}}</label>
            </li>
          </ul>
        </div>
        <div class="giga-flexible_card_actions">
          <button class="work-card_details_button">
            Détails
          </button>
        </div>
      </div>
    </div>
    <!-- <b-card header-tag="header" class="card-grid border-raduis-xl text-center">
      <template #header>
        <h4 class="title text-center font-weight-bold text-primary m-0">
          {{ work.name }}
        </h4>
        <div class="icon">
          <span class="badge-icon ml-auto fsize-3">
            <em class="icomoon icon-bell"></em>
            <span class="badge-icon-number">{{ work.numberOfNotifications }}</span>
          </span>
        </div>
      </template>
      <div class="status">
        <b-badge variant="primary" style="padding:5px 33px; font-size:16px" pill>{{
          $t(work.status)
        }}</b-badge>
      </div>
      <b-row class="pt-4">
        <b-col cols="6" class="border-right py-3">
        <p>  {{ $t("precarious_volume") }} : <strong class="font-weight-bold">{{ work.precarityVolume | formatNumber }} (kWh cumac)</strong></p>

         <p> {{ $t("number_of_lots") }} : <strong class="font-weight-bold">{{ work.numberOflots }}</strong></p>
        </b-col>
        <b-col cols="6" class="py-3">
          <p>{{ $t("classic_volume") }} : <strong class="font-weight-bold">{{ work.classicVolume | formatNumber }} (kWh cumac)</strong> </p>
          <p>{{ $t("number_of_operations") }} : <strong class="font-weight-bold">{{ work.numberOfOperations }}</strong></p>
        </b-col>
      </b-row>
    </b-card> -->
  </b-link>
</template>

<script>
export default {
  name: 'WorkCard',
  props: ['work'],
};
</script>
<style lang="scss" scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-container .tooltip-text {
  visibility: hidden;
  width: auto;
  white-space: nowrap;
  background:#fffc9d;
  color: black;
  text-align: center;
  padding: 6px;
  border-radius: 6px;
  position: absolute;
  z-index: 10;
  top: 125%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  font-size: 12px;
}
.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
.warning-icon,
.rge-icon  {
  width: 22px;
  height: 22px;
  margin-left: 6px;
  vertical-align: middle;
  cursor: pointer;
}
.triangle {
  fill: #fffc9d;
  stroke: black;
  stroke-width: 1px;
  stroke-linejoin: round;
}
.exclamation-mark {
  fill: black;
}
</style>


